/**
 * Solanaland
 *
 * Author: Phia Nasol
 * Company: Digiteer Inc.
 *
 * https://www.digiteer.digital/
 *
 */

import React from "react";

export type RadioButtonProps = React.ComponentPropsWithRef<"input"> & {
  label?: string;
  info?: string;
  required?: boolean;
  errorMessage?: string;
};

const RadioButton = React.forwardRef<HTMLInputElement, RadioButtonProps>((props, ref) => {
  const { label, errorMessage, ...rest } = props;
  const invalid = !!errorMessage;

  return (
    <div className={`mb-3 ${invalid && "field-group--invalid"}`}>
      <label className="radio-label mt-2">
        <input aria-invalid={invalid ? "true" : "false"} type="radio" ref={ref} {...rest} />
        <div className="radio mr-2">
          <div className="circle"></div>
        </div>
        <span className="h5">{label}</span>
      </label>
      {invalid && (
        <div className="field-helper">
          <label>{errorMessage}</label>
        </div>
      )}
    </div>
  );
});

RadioButton.displayName = "RadioButton";

export default RadioButton;
